import React, { useRef, useState } from "react";
import { IoMdClose } from "react-icons/io";
import { MeetingService } from "../../services/MeetingService";
import { toast } from "react-toastify";
import useModalCloseHook from "../../hooks/useModalCloseHook";
import Button from "@mui/material/Button";

const CreateMeeting = ({ isOpen, onClose, setMeetings }) => {
  const modalRef = useRef(null);
  
  useModalCloseHook(modalRef, onClose);
  const [formData, setFormData] = useState({
    title: "",
    date: "",
    time: "",
    agenda: "",
    meetingLink: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await MeetingService.createMeeting(formData);
      if(response){
        toast.success("Meeting created Successfully");
        setMeetings((prev) => [...prev, response]);
        onClose();
        setFormData({
          title: "",
          date: "",
          time: "",
          agenda: "",
          meetingLink: "",
        });
      }
    } catch (error) {
      toast.error(error.message || "Failed to create meeting");
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-40 flex justify-center items-center z-50">
      <div
        ref={modalRef}
        className="bg-white p-6 rounded-2xl w-[90%] max-w-lg shadow-lg relative"
      >
          <IoMdClose onClick={onClose} className="absolute cursor-pointer top-2 right-3 text-gray-500 text-2xl hover:text-red-500" />

       <h2 className="text-2xl font-semibold text-zinc-800 mb-6 text-center">
      Create New Meeting
    </h2>
        <form onSubmit={handleSubmit} className="space-y-4 ">
        
          <input
            type="text"
            name="title"
            placeholder="Meeting Title"
            value={formData.title}
            onChange={handleChange}
            className="w-full border border-zinc-300 px-3 py-2 rounded focus:outline-none"
            required
          />

          <div className="flex gap-4">
            <input
              type="date"
              name="date"
              value={formData.date}
              onChange={handleChange}
              className="w-full border border-zinc-300 px-3 py-2 rounded focus:outline-none"
              required
            />
            <input
              type="time"
              name="time"
              value={formData.endTime}
              onChange={handleChange}
              className="w-full border border-zinc-300 px-3 py-2 rounded focus:outline-none"
              required
            />
          </div>
          
      <textarea
        name="agenda"
        placeholder="Agenda"
        value={formData.agenda}
        onChange={handleChange}
        rows={4}
        className="w-full px-4 py-2 border border-zinc-300 rounded-md resize-none outline-none "
        required
      />
          <input
            type="url"
            name="meetingLink"
            placeholder="Meeting Link"
            value={formData.meetingLink}
            onChange={handleChange}
            className="w-full border border-zinc-300 px-3 py-2 rounded focus:outline-none"
            required
          />

          <Button
            type="submit"
            variant="contained"
            className=" btn-gradient !capitalize  !w-full !p-2 !font-medium !text-white "
          >
            Schedule Meeting
          </Button>
        </form>
      </div>
    </div>
  );
};

export default CreateMeeting;
